<!--核对返点金额-->
<template>
  <div v-permission="'can_order_verify_rebate'" style="margin-right:10px;">
    <el-button class="funcbars-button" @click="handelConfirm">
      <i class="el-icon-finished"/>核对返点
    </el-button>
  </div>
</template>
<script>
import {verifyRebate} from "@/api/adOrder";
import {numberFormat} from "@/utils";

export default {
  name: 'VerifyOrderRebate',
  props: {
    selection: {}
  },
  methods: {
    handelConfirm: function () {
      const selection = this.selection;
      if (!Array.isArray(selection) || !selection.length) {
        this.$notify.warning('请选择要核对返点的订单！');
        return;
      }

      let dom = '';
      let sum = 0
      const order_nos = []

      selection.map(_ => {
        order_nos.push(_.order_no)
        _.rebates_amount = _.rebates_amount || 0
        sum = this.$bigNumber(sum).plus(_.rebates_amount).toNumber()
        dom +=
          `<div>
                <b>${_.order_no}</b> |
                <span>返点：</span><b>￥ ${_.rebates_amount}</b>
           </div>`;

      })

      sum = numberFormat(sum, 2)
      // A1111111111111111 占位用 为了对齐
      dom += `<div style="border-top: 1px solid #333;"><b style="opacity: 0;">A1111111111111111 | </b><span>总计：</span><b>￥ ${sum}</b> </div>`;

      this.$confirm(
        `<div style="max-height: 500px;overflow-y: auto;">${dom}</div>`,
        '确认以下订单已完成核对返点吗？',
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          cancelButtonText: '再看看',
          type: 'warning'
        })
        .then(async () => {
          const response = await verifyRebate({order_nos, mark: 'Y'})
          if (!response.success) {
            this.$message.error(response.message || '系统服务异常')
            return;
          }
          this.$emit('success')
        })
    }
  }
}
</script>

<style scoped>

</style>
